import React, { Component } from 'react'
import injectSheet from 'react-jss'
import styles from './my-files.styles'
import MyFilesTable from './my-files-table/my-files-table.container'
import CurrentSkeleton from './my-files-skeleton/current-skeleton'
import usingmoderation from './hero-image-2.png'
import { Link } from 'react-router-dom'
import ArrowIcon from 'react-icons/lib/fa/caret-right'
import { Pagination } from 'pobble-components/dist/pagination'
import classNames from 'classnames'

class MyFiles extends Component {
  componentDidMount() {
    this.props.onMount()
  }
  render() {
    const {
      classes,
      pending,
      noFiles,
      pagination,
      onPageChange,
      restrictedFromCreatingAFs
    } = this.props
    let files = noFiles ? (
      <div>
        <img
          src={usingmoderation}
          className={classNames(classes.illustration, {
            [classes.restricted]: restrictedFromCreatingAFs
          })}
          alt="Not Found"
        />
        {!restrictedFromCreatingAFs && (
          <p className={classes.container}>
            <strong>Ready to start?</strong> <br />
            <br />
            <a
              className={classes.link}
              href="https://www.loom.com/share/0bc098cdd69b492db830d79e5e93c991"
              target="_blank"
              rel="noopener noreferrer">
              Watch our video
            </a>{' '}
            and learn how you can create and <br />
            share your first moderation files.
            <br />
            <br />
            Once ready, create your first file by{' '}
            <a className={classes.link} href="/actions">
              uploading writing
            </a>{' '}
            or <br />
            select work already in the{' '}
            <a className={classes.link} href="/actions">
              pupil's evidence bank
            </a>
            .
          </p>
        )}
        {restrictedFromCreatingAFs && (
          <p className={classes.container}>
            The ability to create and share moderation files is only available
            to those with active moderation subscriptions.
            <br />
            <br />
            <a
              className={classes.link}
              href="https://www.pobble.com/pricing-moderation"
              target="_blank"
              rel="noopener noreferrer">
              Purchase a subscription
            </a>{' '}
            or{' '}
            <a
              className={classes.link}
              href="https://www.pobble.com/webinars"
              target="_blank"
              rel="noopener noreferrer">
              join a free webinar
            </a>{' '}
            to find out more.
          </p>
        )}
      </div>
    ) : pending ? (
      <CurrentSkeleton />
    ) : (
      <div>
        <MyFilesTable />
        <div className={classes.pagination}>
          <Pagination onPageChange={onPageChange} data={pagination} />
        </div>
      </div>
    )

    return (
      <>
        {files}
        <div className={classes.archived}>
          <Link className={classes.link} to={'/my-files/archived'}>
            Archived files <ArrowIcon />
          </Link>
        </div>
      </>
    )
  }
}

export default injectSheet(styles)(MyFiles)
